import { Card } from "../../../../components";
import { ScoreCard } from "./ScoreCard";

export const GatewayScoreAndSummary = ({ data, isLoading }) => {
  if (!data) return <></>;
  return (
    <div className="flex flex-1 flex-col gap-4">
      <div className="flex flex-row justify-between items-center">
        <span className="font-ibm-plex-sans text-[16px] font-bold leading-[24px] text-left">
          Gateway Score and Summary
        </span>
      </div>
      <div className="flex flex-nowrap gap-4">
        <div className="flex">
          <Card className="p-6" secondary>
            <div className="flex flex-1 flex-col justify-center items-center gap-1">
              <span className="font-ibm-plex-sans text-[24px] font-bold leading-[32px] text-center text-[#007DFF]">
                {isLoading
                  ? "0.00"
                  : data?.executiveSummary?.gatewayScore.toFixed(2)}
              </span>
              <span className="font-ibm-plex-sans text-[12px] font-normal leading-[16px] text-center">
                Total
              </span>
            </div>
          </Card>
        </div>
        <div className="flex grow">
          <div className="flex grow flex-col gap-4">
            <div className="flex gap-2 items-center">
              <span className="font-ibm-plex-sans text-[14px] font-normal leading-[20px] text-[#FFFFFF88]">
                Investment recommendation:
              </span>
              <span className="font-ibm-plex-sans text-[16px] font-medium leading-[24px]">
                {data?.executiveSummary?.investmentRecommendation}
              </span>
            </div>
            <div className="flex flex-col gap-1 hidden md:block">
              <span className="font-ibm-plex-sans text-[14px] font-normal leading-[20px] text-[#FFFFFF88]">
                Component scores:
              </span>

              <div className="flex flex-nowrap gap-2">
                <ScoreCard
                  title="Technical Analysis"
                  score={
                    isLoading
                      ? "0.0"
                      : data?.executiveSummary?.componentScores.technicalAnalysis.toFixed(
                          1,
                        )
                  }
                />
                <ScoreCard
                  title="Fundamental Analysis"
                  score={
                    isLoading
                      ? "0.0"
                      : data?.executiveSummary?.componentScores.fundamentalAnalysis.toFixed(
                          1,
                        )
                  }
                />
                <ScoreCard
                  title="Social Score"
                  score={
                    isLoading
                      ? "0.0"
                      : data?.executiveSummary?.componentScores.socialScore.toFixed(
                          1,
                        )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-1 md:hidden">
        <span className="font-ibm-plex-sans text-[14px] font-normal leading-[20px] text-[#FFFFFF88]">
          Component scores:
        </span>

        <div className="flex flex-col flex-nowrap gap-2">
          <ScoreCard
            title="Technical Analysis"
            score={
              isLoading
                ? "0.0"
                : data?.executiveSummary?.componentScores.technicalAnalysis.toFixed(
                    1,
                  )
            }
          />
          <ScoreCard
            title="Fundamental Analysis"
            score={
              isLoading
                ? "0.0"
                : data?.executiveSummary?.componentScores.fundamentalAnalysis.toFixed(
                    1,
                  )
            }
          />
          <ScoreCard
            title="Social Score"
            score={
              isLoading
                ? "0.0"
                : data?.executiveSummary?.componentScores.socialScore.toFixed(1)
            }
          />
        </div>
      </div>
      <div className="flex grow font-ibm-plex-sans text-[16px] font-normal leading-[24px]">
        {isLoading ? "loading..." : data?.executiveSummary?.overview}
      </div>
    </div>
  );
};
